const Logo = () => {

    return (<img src="https://www.salubrishealth.com/images/logo.svg" alt="Salubris Logo" />);
}

export default Logo;